// extracted by mini-css-extract-plugin
module.exports = {"container":"ControlPanelHeader_container__1vgLi","title":"ControlPanelHeader_title__2UHdp"};